import { Box, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { ILegalClientRelationship } from '../../Interfaces/ILegalClientRelationship/ILegalClientRelationship';
import { ILegalTransaction } from '../../Interfaces/ILegalTransaction';
import { ILegalClientFullObject } from '../../Interfaces/ILegalClient';
import { useDownloadDocument } from '../../hooks/reactQuerys/DocumentQueries';
import DownloadIcon from '@mui/icons-material/Download';

interface IProps {
  legalClientId: number;
  relationships: ILegalClientRelationship[];
  legalTransactions: ILegalTransaction[];
  formValues: ILegalClientFullObject;
  setFormValues: React.Dispatch<React.SetStateAction<ILegalClientFullObject>>;
}

const DOCUMENT_TYPES = {
  AD: { id: 20, label: 'Aktueller Abdruck' },
  SI: { id: 21, label: 'Strukturierter Registerinhalt' },
  GL: { id: 22, label: 'Gesellschafterliste' },
} as const;

const TYPE_LABEL_BY_ID = Object.fromEntries(
  Object.values(DOCUMENT_TYPES).map(t => [t.id, t.label])
) as Record<number, string>;

export const DocumentTab = ({ formValues, setFormValues }: IProps) => {
  const documents = formValues.Documents ?? [];
  const { downloadDocument, isPending: isDownloading } = useDownloadDocument();

  const handleDelete = (idDocument: number) => {
    setFormValues(prev => ({
      ...prev,
      Documents: prev.Documents.filter(doc => doc.idDocument !== idDocument),
    }));
  };

  return (
    <Box>
      <Typography variant='h6' sx={{ mb: 2 }}>
        Vorhandene Dokumente
      </Typography>

      <Grid container spacing={1}>
        {documents.map(doc => (
          <Grid item xs={12} key={doc.idDocument}>
            <Box
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              sx={{
                border: '1px solid #ddd',
                borderRadius: 1,
                p: 1.5,
              }}
            >
              <Box>
                <Typography>{doc.FileName}</Typography>
                <Typography variant='caption' color='text.secondary'>
                  {TYPE_LABEL_BY_ID[doc.idLegalClientDocumentType] ??
                    'Unbekannter Dokumenttyp'}
                </Typography>
              </Box>

              <Box display='flex' alignItems='center' gap={1}>
                <Tooltip title='Dokument entfernen'>
                  <IconButton onClick={() => handleDelete(doc.idDocument)}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title='Dokument herunterladen'>
                  <IconButton
                    onClick={() => downloadDocument(doc.idDocument)}
                    disabled={isDownloading}
                  >
                    <DownloadIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          </Grid>
        ))}

        {documents.length === 0 && (
          <Grid item xs={12}>
            <Typography variant='body2' color='text.secondary'>
              Keine Dokumente vorhanden.
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
